import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapPath } from '../../mappers';

import { TReduxActions } from '../../types/redux';

const defaultState = '';

export function pathReducer(state: string = defaultState, action: TReduxActions) {
  if (action.type === EPromosActionTypes.Success || action.type === EPaginationActionTypes.Success) {
    return mapPath(action.payload);
  }

  return state;
}
